/* eslint-disable jsx-a11y/anchor-is-valid */
/* eslint-disable jsx-a11y/no-static-element-interactions */
/* eslint-disable jsx-a11y/click-events-have-key-events */
import React, { useContext, useEffect } from 'react';
import './styled.css';
import Draggable from 'react-draggable';
import { AppContext } from '../../context';

const Chat = ({ minimize, close, urlChat, className, ...rest }) => (
  <section id="chat-float" className={`${className} chat-float`} {...rest}>
    <header className="chat-header">
      <p>Chat</p>
      <div className="chat-options">
        <a id="id-minimize" onClick={() => minimize()}>
          <i className="icon icon-menos" />
        </a>
        <a onClick={() => close()}>
          <i className="icon icon-fechar" />
        </a>
      </div>
    </header>
    <iframe
      className="chat-iframe"
      title="iframe"
      sandbox={`allow-forms allow-modals allow-orientation-lock allow-pointer-lock allow-popups allow-popups-to-escape-sandbox
   allow-presentation allow-same-origin allow-scripts allow-top-navigation allow-top-navigation-by-user-activation`}
      src={urlChat}
    />
  </section>
);

const EmbeddedChat = ({ isMobile }) => {
  const { urlChat, showEmbeddedChat, minimized, setContext } = useContext(
    AppContext
  );

  const chatFloatRef = state => {
    document.getElementById('chat-float').style.display = state;
  };

  useEffect(() => {
    if (!showEmbeddedChat) {
      return;
    }
    if (minimized) {
      chatFloatRef('none');
    } else {
      chatFloatRef('block');
    }
  }, [minimized, showEmbeddedChat]);

  const minimize = () => {
    setContext({
      minimized: true,
    });
  };

  const close = () => {
    setContext({
      urlChat: '',
      showEmbeddedChat: false,
    });
    chatFloatRef('none');
  };

  if (!showEmbeddedChat) {
    return null;
  }

  return (
    <>
      {!isMobile ? (
        <Draggable bounds="parent">
          <Chat minimize={minimize} close={close} urlChat={urlChat} />
        </Draggable>
      ) : (
        <Chat minimize={minimize} close={close} urlChat={urlChat} />
      )}
    </>
  );
};

export default EmbeddedChat;
